export const CATEGORY_ORDER = [
  "Registration & Onboarding",
  "Profile completion",
  "Job actions — locum",
  "Job actions — permanent & international",
  "Engagement — app launch streak",
  "Engagement — profile re-updates",
  "Referral rewards",
];

export function defEvent(coins, extra = {}) {
  return {
    coins,
    oneTime: false,
    dailyLimit: null,
    monthlyLimit: null,
    cooldownDays: null,
    expiryDays: null,
    version: 1,
    updatedBy: null,
    updatedAt: null,
    ...extra,
  };
}

export const DEFAULT_EVENT_CONFIG = {
  NEW_JOINER_REWARD: defEvent(100, {
    cat: "Referral rewards",
    oneTime: true,
    name: "New Joiner Reward",
    desc: "Coins awarded to a professional who signs up using a referral code",
  }),
  REFERRAL_WELCOME_BONUS: defEvent(100, {
    cat: "Referral rewards",
    oneTime: true,
    name: "Referral Welcome Bonus",
    desc: "A user who signs up successfully using a referral code should receive a one-time reward of 100 coins.",
  }),
  // UPLOAD_RESUME: defEvent(10, {
  //   cat: "Registration & Onboarding",
  //   oneTime: true,
  //   name: "Resume Uploaded",
  //   desc: "First resume file uploaded to profile",
  // }),
  // DOCUMENT_DECLARATION: defEvent(30, {
  //   cat: "Registration & Onboarding",
  //   oneTime: true,
  //   name: "Document Declaration Submitted",
  //   desc: "Signed the mandatory document declaration",
  // }),
  // BASIC_INFO_100: defEvent(10, {
  //   cat: "Profile completion",
  //   oneTime: true,
  //   name: "Basic Info 100% Complete",
  //   desc: "Name, contact, and specialisation fully filled in",
  // }),
  // PAN_BANK_SUBMITTED: defEvent(10, {
  //   cat: "Profile completion",
  //   oneTime: true,
  //   name: "PAN & Bank Details Submitted",
  //   desc: "Payout details added and verified",
  // }),
  // QUALIFICATION_100: defEvent(15, {
  //   cat: "Profile completion",
  //   oneTime: true,
  //   name: "Qualification Details 100% Complete",
  //   desc: "Degree / diploma details fully filled in",
  // }),
  // WORK_EXPERIENCE_100: defEvent(15, {
  //   cat: "Profile completion",
  //   oneTime: true,
  //   name: "Work Experience 100% Complete",
  //   desc: "At least one prior role added in full",
  // }),
  // BACKGROUND_REFERENCE_100: defEvent(15, {
  //   cat: "Profile completion",
  //   oneTime: true,
  //   name: "Background Reference 100% Complete",
  //   desc: "Reference and background details fully filled in",
  // }),
  // FIRST_LOCUM_BGV_APPROVED: defEvent(200, {
  //   cat: "Job actions — locum",
  //   oneTime: true,
  //   name: "First Locum BGV Approved",
  //   desc: "Background verification cleared for the first locum shift",
  // }),
  // LOCUM_JOB_APPLY: defEvent(10, {
  //   cat: "Job actions — locum",
  //   dailyLimit: 5,
  //   monthlyLimit: 50,
  //   name: "Locum Job Application Submitted",
  //   desc: "Applied to a posted locum shift",
  // }),
  // MARK_IN: defEvent(10, {
  //   cat: "Job actions — locum",
  //   name: "Shift Mark-In",
  //   desc: "Checked in at the start of a shift",
  // }),
  // MARK_OUT: defEvent(10, {
  //   cat: "Job actions — locum",
  //   name: "Shift Mark-Out",
  //   desc: "Checked out at the end of a shift",
  // }),
  // PERMANENT_JOB_APPLY: defEvent(25, {
  //   cat: "Job actions — permanent & international",
  //   monthlyLimit: 5,
  //   name: "Permanent Job Applied",
  //   desc: "Applied to a permanent placement role",
  // }),
  // INTERNATIONAL_JOB_APPLY: defEvent(25, {
  //   cat: "Job actions — permanent & international",
  //   monthlyLimit: 5,
  //   name: "International Job Applied",
  //   desc: "Applied to an international placement role",
  // }),
  // INTERNATIONAL_EXAM_YES: defEvent(5, {
  //   cat: "Job actions — permanent & international",
  //   monthlyLimit: 5,
  //   name: "International Exam Interest Confirmed",
  //   desc: "Confirmed intent to take the international licensing exam",
  // }),
  // STREAK_DAY_1: defEvent(5, {
  //   cat: "Engagement — app launch streak",
  //   name: "App Launch Streak — Day 1",
  //   desc: "1st consecutive day the app was opened",
  // }),
  // STREAK_DAY_2: defEvent(10, {
  //   cat: "Engagement — app launch streak",
  //   name: "App Launch Streak — Day 2",
  //   desc: "2nd consecutive day the app was opened",
  // }),
  // STREAK_DAY_3: defEvent(15, {
  //   cat: "Engagement — app launch streak",
  //   name: "App Launch Streak — Day 3",
  //   desc: "3rd consecutive day the app was opened",
  // }),
  // STREAK_DAY_4: defEvent(20, {
  //   cat: "Engagement — app launch streak",
  //   name: "App Launch Streak — Day 4",
  //   desc: "4th consecutive day the app was opened",
  // }),
  // STREAK_DAY_5: defEvent(25, {
  //   cat: "Engagement — app launch streak",
  //   name: "App Launch Streak — Day 5",
  //   desc: "5th consecutive day the app was opened — cycle repeats after this",
  // }),
  // UPDATE_QUALIFICATION: defEvent(10, {
  //   cat: "Engagement — profile re-updates",
  //   cooldownDays: 180,
  //   name: "Qualification Re-updated",
  //   desc: "Refreshed qualification details",
  // }),
  // UPDATE_WORK_EXPERIENCE: defEvent(10, {
  //   cat: "Engagement — profile re-updates",
  //   cooldownDays: 180,
  //   name: "Work Experience Re-updated",
  //   desc: "Refreshed work experience details",
  // }),
  // UPDATE_SPECIALISATION: defEvent(10, {
  //   cat: "Engagement — profile re-updates",
  //   cooldownDays: 90,
  //   name: "Specialisation Re-updated",
  //   desc: "Refreshed specialisation",
  // }),
  // UPDATE_SKILL: defEvent(10, {
  //   cat: "Engagement — profile re-updates",
  //   cooldownDays: 90,
  //   name: "Skills Re-updated",
  //   desc: "Refreshed skill tags",
  // }),
  // UPDATE_REGISTRATION_EXPIRY: defEvent(10, {
  //   cat: "Engagement — profile re-updates",
  //   name: "Registration Renewed",
  //   desc: "Renewed an expiring registration/license — condition-gated, not cooldown",
  // }),
};

export const DEFAULT_REFERRAL_LEVELS = [
  {
    level: 1,
    coins: 100,
    signupExpiryDays: null,
    firstShiftBonus: 200,
    firstShiftExpiryDays: null,
    nameVisible: true,
    status: "active",
    updatedBy: null,
    updatedAt: null,
  },
  {
    level: 2,
    coins: 25,
    signupExpiryDays: null,
    firstShiftBonus: null,
    firstShiftExpiryDays: null,
    nameVisible: false,
    status: "active",
    updatedBy: null,
    updatedAt: null,
  },
  {
    level: 3,
    coins: 10,
    signupExpiryDays: null,
    firstShiftBonus: null,
    firstShiftExpiryDays: null,
    nameVisible: false,
    status: "active",
    updatedBy: null,
    updatedAt: null,
  },
  {
    level: 4,
    coins: 5,
    signupExpiryDays: null,
    firstShiftBonus: null,
    firstShiftExpiryDays: null,
    nameVisible: false,
    status: "active",
    updatedBy: null,
    updatedAt: null,
  },
  {
    level: 5,
    coins: 2,
    signupExpiryDays: null,
    firstShiftBonus: null,
    firstShiftExpiryDays: null,
    nameVisible: false,
    status: "active",
    updatedBy: null,
    updatedAt: null,
  },
];
